import { Prismic, PrismicText } from '@landsbankinn/prismic';
import { Segment } from '@landsbankinn/ui';
import React from 'react';
import { StaffBioCard } from '../components/card/StaffBioCard';
import { StaffWithBio } from '../components/slices/StaffWithBio';

interface IProps {
  fields: IField[];
  title: Prismic.RichText;
}

interface IField {
  employee: IEmployee;
}

interface IEmployee {
  image: Prismic.Image;
  name: Prismic.RichText;
  title: Prismic.RichText;
  bio: Prismic.RichText;
}

export const StaffWithBioContainer = ({ fields, title }: IProps) => {
  const items = fields?.filter(({ employee }) => employee);
  if (items.length === 0) {
    return null;
  }
  return (
    <Segment>
      <StaffWithBio title={Prismic.text(title)}>
        {fields?.map(({ employee: { image, name, title, bio } }, index) => (
          <StaffBioCard
            image={image}
            key={`staff-item-${index}`}
            name={Prismic.text(name)}
            title={Prismic.text(title)}
            bio={<PrismicText value={bio} />}
          />
        ))}
      </StaffWithBio>
    </Segment>
  );
};
